import { render, staticRenderFns } from "./WarehouseInfo.vue?vue&type=template&id=28373cfc&scoped=true&"
import script from "./WarehouseInfo.vue?vue&type=script&lang=js&"
export * from "./WarehouseInfo.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseInfo.vue?vue&type=style&index=0&id=28373cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28373cfc",
  null
  
)

export default component.exports